import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 35rem;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding-top: 1.875rem;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  margin-top: 2rem;
  flex-direction: column;
  align-items: center;
  font-family: Sora;
  div {
    margin-bottom: 0.5rem;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;

  div {
    border: 2px solid #d4d6da;
    padding: 0 0 0.5rem 0;
    width: 25rem;
    border-radius: 8.47434px;
  }

  span {
    font-size: 0.75rem;
    color: #585e66;
    font-weight: 600;
  }

  p {
    text-align: start;
    padding-left: 1rem;
    padding-top: 0.6rem;
    line-height: 1rem;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;

  span {
    font-size: 0.75rem;
    color: #585e66;
    font-weight: 600;
  }
  div {
    border: 2px solid #d4d6da;
    padding: 0 0 0.5rem 0;
    width: 25rem;
    border-radius: 8.47434px;
    min-height: 6rem;
  }

  p {
    text-align: start;
    padding-left: 1rem;

    padding-top: 0.6rem;
    padding: 0.6rem 1rem 0 1rem;
    line-height: 1rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${({ loading }) => loading ? "#584e66" : "#584e66"};
  padding-top: 0.9375rem;
`;



export const FlowName = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.875rem;

  color: #585e66;

  padding-top: 3.3125rem;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;

  padding-top: 4.1875rem;
  padding-bottom: 1.875rem;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
